module.exports = __webpack_public_path__ + "img/dok_fav.c603904a.png";